export const guestConstants = {
    GUEST_DASHBOARD_LOADING: 'GUEST_DASHBOARD_LOADING',
    GUEST_DASHBOARD_SUCCESS: 'GUEST_DASHBOARD_SUCCESS',
    GUEST_DASHBOARD_FAILED: 'GUEST_DASHBOARD_FAILED',
};
